import type { RemoveSelectionAreaFromPlan } from "./types";

export const removeSelectionAreaFromPlan: RemoveSelectionAreaFromPlan = ({
  plan,
  areaId,
}) => ({
  ...plan,
  selectionAreas: plan.selectionAreas.filter((area) => area.id !== areaId),
});
